import { Text } from "pixi.js";

export default class Distance {
  public sprite: Text;
  constructor(sprite: Text) {
    this.sprite = sprite;
  }

  setText(score: number): void {
    var numberText = score + "";
    var zeros = "";
    for (let index = 0; index < 4 - numberText.length; index++) {
      zeros += "0";
    }
    var str = `Score:${zeros + numberText}`;
    this.sprite.text = str;
  }

  reset() {
    this.sprite = null as any;
  }
}
